import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Resources from "@/pages/Resources";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import ProjectSubmit from "@/pages/ProjectSubmit";
import Committees from "@/pages/Committees";
import SolicitSupport from "@/pages/SolicitSupport";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MemberDashboard from "@/pages/MemberDashboard";
import MemberDirectory from "@/pages/MemberDirectory";
import NotFound from "@/pages/NotFound";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminEvents from "@/pages/admin/AdminEvents";
import AdminResources from "@/pages/admin/AdminResources";
import AdminNews from "@/pages/admin/AdminNews";
import AdminCommittees from "@/pages/admin/AdminCommittees";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              style: { borderRadius: "10px", border: "1px solid #EAE4D8", fontFamily: "Manrope, sans-serif" },
            }}
          />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/projects/submit" element={<ProjectSubmit />} />
              <Route path="/committees" element={<Committees />} />
              <Route path="/solicit-support" element={<SolicitSupport />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<ProtectedRoute><MemberDashboard /></ProtectedRoute>} />
              <Route path="/directory" element={<ProtectedRoute><MemberDirectory /></ProtectedRoute>} />
              <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
                <Route index element={<Navigate to="events" replace />} />
                <Route path="events" element={<AdminEvents />} />
                <Route path="resources" element={<AdminResources />} />
                <Route path="news" element={<AdminNews />} />
                <Route path="committees" element={<AdminCommittees />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
